import "./GratuityList.scss";

import React from "react";
import { Link } from "react-router-dom";
import usesFeatures from "usesFeatures"

import Table from "Table"
import Header from "Header"

class GratuityList extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    this.props.fetchData("/venue_admin/gratuities")
  }

  emptyTable = () => (
    <h3 className="is-size-6 is-italic">
      No Gratuities Found. Time to <Link to={`/gratuities/new`}>create one</Link>?
    </h3>
  )

  headers = () => ({
    name: "Gratuity Name",
    gratuity_amount: "Amount",
    auto_apply: "Auto",
    edit: "",
  })

  formatters = () => ({
    name: (g) => <Link to={`/gratuities/${g.id}`}>{g.name}</Link>,
    gratuity_amount: (g) => g.gratuityUnit === "percent" ? `${g.gratuityAmount}%` : `$${g.gratuityAmount}`,
    auto_apply: (g) => g.autoApply ? "Yes" : "—",
    edit: (g) => <Link to={`/gratuities/${g.id}/edit`}>Edit</Link>,
  })

  render() {
    if (!this.props.dataFetched) return false

    return(
      <div className="GratuityList">
        <Header text="Gratuities" actions={true}>
          <Link to="/gratuities/new" className="button is-primary">New Gratuity</Link>
        </Header>
        <div key="gratuitiestable" className="block">
          <h3 className="title">Gratuities</h3>
          <Table
            empty={this.emptyTable()}
            showHeader={true}
            headers={this.headers()}
            formatters={this.formatters()}
            rows={this.props.gratuities}
            tdClasses={TD_CLASSES}
          />
        </div>
      </div>
    )
  }
}

const TD_CLASSES = {
  gratuity_amount: "is-narrow pr-4",
  auto_apply: "is-narrow",
  edit: "is-narrow",
}

export default usesFeatures(["data"], GratuityList)
